import { type, string, optional, number } from 'superstruct';
export const MULTISTEP_FORM_LOCAL_STORAGE_KEY = 'gift-wrapping:multistep';
export const GiftBoxDescription = type({
    id: number(),
    description: optional(string())
});
export const initialContext = {
    giftbox: '',
    variant: '',
    items: [],
    giftboxMessage: '',
    complimentaryMessage: ''
};
